import axios from "axios";
import Swal from "sweetalert2";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// REQUEST INTERCEPTOR
axiosClient.interceptors.request.use(
  (config) => {
    let userData = localStorage.getItem("userData");

    try {
      userData = userData ? JSON.parse(userData) : null;
    } catch (e) {
      userData = null;
    }

    if (userData?.token) {
      config.headers.Authorization = `Bearer ${userData.token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR
axiosClient.interceptors.response.use(
  (response) => response,

  async (error) => {
    if (error.response?.status === 401) {
      // 🔥 DO NOT CLEAR STORAGE HERE (else auto redirect happens)

      // Show Swal and wait for OK click
      const result = await Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please log in again.",
        confirmButtonText: "OK",
        allowOutsideClick: false, // prevents closing accidentally
      });

      // If user clicked OK → logout + redirect
      if (result.isConfirmed) {
        localStorage.clear();
        window.location.href = "/login";
      }

      return;
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
